// Toast Message
export const TOAST_MSG_CONSENT_POPUP_HIDDEN =
  '가격 변경 동의 요청 팝업을 7일동안 보지 않습니다.'
export const TOAST_MSG_CONSENT_AGREED = '가격 변경에 동의해주셔서 감사합니다.'
export const TOAST_MSG_CONSENT_AGREE_ERROR =
  '가격 변경 동의 기간이 아니거나, 해당 사용자가 아닙니다.'
export const TOAST_MSG_NETWORK_ERROR = `서비스 연결이 지연되고 있습니다.\n잠시 후 이용해 주세요.\n증상 지속 시 Wavve 고객센터로 문의해 주세요.`
export const TOAST_MSG_ALREADY_AGREED = `이미 가격 변경에 동의하셨습니다. 웨이브와 함께 해주셔서 감사합니다.`
export const TOAST_MSG_CONSENT_DISAGREED = `가격 변경에 동의하지 않으셨습니다.\n이용권 내역에서 동의하실 수 있습니다.`

// invalid user error
export const ERROR_MSG_TITLE_INVALID_USER = '웨이브에서 안내드립니다.'
export const ERROR_MSG_TEXT_INVALID_USER = `이미 가격 변경에 동의하셨거나,\n동의 기간 혹은 동의가 필요한 사용자가 아닙니다.\n\n가격 변경 동의가 필요하시다면,\n동의가 필요한 계정으로 로그인 후\n마이 > 이용권 내역에서\n가격 변경 동의가 가능한 지 확인해주세요.`

// consent promotion component text
export const CONSENT_PROMOTION_TITLE = `프로모션 기간 동안\n즐거운 시청 경험 하셨나요?`
export const CONSENT_PROMOTION_DESCRIPTION = `안녕하세요, Wavve입니다.\n\n고객님께서 사용 중인 Wavve 이용권의 가격이 __START_DATE__부터 변경될 예정입니다. 계속해서 Wavve를 이용하시려면 __DUE_DATE__까지 아래의 변경된 가격에 동의해 주세요.\n\n항상 Wavve를 이용해 주셔서 감사합니다.`
export const CONSENT_PROMOTION_NOTICE_LIST = [
  `가격 변경에 동의하신 후에도 웨이브 서비스 마이/이용권 내역에서 이용권 내역의 변경 및 자동결제 취소가 가능합니다.`,
]

// router path
export const ROUTER_PATH_CONSENT_PROMOTION = '/consent/promotion'

// SessionStorage Key
export const SS_KEY_SHOULD_CHECK_CONSENT = 'shouldCheckConsent'

// Cookie Key
export const COOKIE_KEY_IS_CONSENT_POPUP_HIDDEN = 'isConsentPopupHidden'
export const COOKIE_EXPIRY_DAYS = 7

// response action type
export const ACTION_TYPE_SHOW_POPUP = 'SHOW_POPUP'
export const ACTION_TYPE_SHOW_DETAIL_POPUP = 'SHOW_DETAIL_POPUP'
export const ACTION_TYPE_NONE = 'NONE'

// error code
export const ERROR_CODE_UNAUTHORIZED = '401.000'
